import { ISimpleImageTitle } from "@faire/web-api/indigofair/data/ISimpleImageTitle";

export const getTeamMemberProfileImages = (
  teamMemberUserData: ISimpleImageTitle
) => {
  return teamMemberUserData.image
    ? [teamMemberUserData.image]
    : [...teamMemberUserData.images].reverse().slice(0, 3);
};
